import Overlay from "../../../Componentes/Overlay";
import SidebarMenu from "../../../Componentes/SideMenu";
import SideMenuBtn from "../../../Componentes/SideMenuBtn";
import { useModal } from "../../../contexts/ModalContext";

const SidebarPedidos = () => {

    const { closeModal, openModal } = useModal();

    const handleOpenNovoPedidoCompra = () => {

        closeModal();
        openModal("modalNovoPedidoCompra");

    }

    return (
        <>
            <Overlay state={ true } changeContent={ closeModal } >
                <SidebarMenu>
                    <SideMenuBtn
                        button="NOVO PEDIDO DE COMPRA"
                        clickFunc={ handleOpenNovoPedidoCompra }
                    />
                </SidebarMenu>
            </Overlay>
        </>
    )
}

export default SidebarPedidos;